import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadAgreements = (context, folderId) => new Promise((resolve, reject) => {
  Api.folderService.getInspectionAgreements(folderId)
    .then(response => {
      context.commit('setAgreements', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setAgreements', []);

      const httpError = Http.createError(
        error,
        'folders.actions.loadAgreements',
        { folderId },
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

const saveAgreements = (context, data) => new Promise((resolve, reject) => {
  context.commit('setSaveAgreementsLoading', true);
  context.commit('setSaveAgreementsError', null);

  Api.folderService.postInspectionAgreements(data.folderId, data.agreements)
    .then(response => {
      context.commit('setAgreements', response.data);
      context.commit('setSaveAgreementsLoading', false);
      resolve();
    })
    .catch(error => {
      context.commit('setAgreements', []);
      context.commit('setSaveAgreementsError', error);
      context.commit('setSaveAgreementsLoading', false);

      const httpError = Http.createError(
        error,
        'folders.actions.saveAgreements',
        data,
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

const setAgreements = (context, agreements) => {
  context.commit('setAgreements', agreements);
};

const setTemplateKey = (context, templateKey) => {
  context.commit('setTemplateKey', templateKey);
};

export default {
  loadAgreements,
  saveAgreements,
  setTemplateKey,
  setAgreements,
};
